<template>
  <div class="custom-control custom-switch custom-control-lg mb-3">
    <input
      type="checkbox"
      class="custom-control-input"
      :id="name"
      v-bind="$attrs"
      @change="$emit('input', $event.target.checked)"
      v-bind:value="value"
      :true-value="true"
      :false-value="false"
      :checked="value"
    />
    <label class="custom-control-label" :for="name"></label>
  </div>
</template>

<script>
export default {
  name: "Switcher",
  inheritAttrs: false,
  props: ["name", "value", "label"],
  // props: {
  //   label: String,
  //   name: String,
  //   value: [Boolean, String],
  // },
  data() {
    return {
      checked: true,
    };
  },
};
</script>

<style>

</style>